import DiagnosticType from '../../constants/DiagnosticType';

export interface DiagnosticTypeDescriptionId {__diagnosticTypeDescriptionId: number}

export default class DiagnosticTypeDescription {
  id!: DiagnosticTypeDescriptionId;
  type!: DiagnosticType;
  description = '';
  isActive = false;
  hasTimer = false;
  hasComment = false;

  isCustom(): boolean {
    return this.type >= DiagnosticType.TEXT;
  }
}